<template>
  <div class="execution-context-container">
    <v-list density="compact" :lines="false" :opened="expanded" class="execution-context-list">
      <div v-for="scope in scopes" :key="scope.name">
        <v-list-group
          v-if="scope.kind === 'composite'"
          :value="scope.name"
          expand-icon="mdi-menu-down"
          collapse-icon="mdi-menu-up"
        >
          <template #activator="{ props }">
            <composite-slot class="px-5" v-bind="props" :item="scope" />
          </template>

          <div v-for="element in scope.elements" :key="element.name">
            <event-slot
              v-if="element.kind === 'event'"
              :item="element"
              @event-raised="emit('eventRaised', $event)"
              @value-changed="emit('valueChanged', $event)"
            />
            <variable-slot
              v-else-if="element.kind === 'variable'"
              :item="element"
              :icon="'mdi-variable-box'"
              @value-changed="emit('valueChanged', $event)"
            />
            <variable-slot
              v-else-if="element.kind === 'operation'"
              :item="element"
              :icon="'mdi-function'"
              @value-changed="emit('valueChanged', $event)"
            />
          </div>
        </v-list-group>
        <v-list-item
          v-else-if="scope.name !== 'triggerWithoutEvent' && scope.name !== 'stateConfVectorPosition'"
          class="pa-0"
        >
          <event-slot
            v-if="scope.kind === 'event'"
            :item="scope"
            @event-raised="emit('eventRaised', $event)"
            @value-changed="emit('valueChanged', $event)" />

          <variable-slot
            v-else-if="scope.kind === 'variable'"
            :item="scope"
            :icon="'mdi-variable-box'"
            @value-changed="emit('valueChanged', $event)" />
          <variable-slot
            v-else-if="scope.kind === 'operation'"
            :item="scope"
            :icon="'mdi-function'"
            @value-changed="emit('valueChanged', $event)"
        /></v-list-item>
      </div>
    </v-list>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { SimulationContext } from "../Editor/services/simulation/simulation-control";
import CompositeSlot from "./CompositeSlot.vue";
import EventSlot from "./EventSlot.vue";
import VariableSlot from "./VariableSlot.vue";

const emit = defineEmits(["eventRaised", "valueChanged"]);

const compProps = defineProps<{ context: SimulationContext }>();

const scopes = computed(() => {
  return compProps.context.elements;
});

const expanded = computed(() => {
  return scopes.value?.map((e) => e.name).filter((n) => n !== "time events");
});
</script>
<style scoped>
.v-list-item {
  padding: 0px 16px;
}
.v-list {
  padding: 0px 0px;
}
.v-list-item--density-compact {
  min-height: 24px;
}
::-webkit-scrollbar-thumb {
  background: rgb(var(--v-theme-contrast-grey-medium));
}
</style>
<style>
.v-list-item-title {
  font-size: 0.8rem;
}
.flex-container {
  display: flex;
  gap: 5px;
}

.spacer {
  flex-grow: 1;
}
.flex-item-end {
  margin-left: auto;
}
.context-input {
  width: 50px;
  border-bottom: 1px solid rgb(var(--v-theme-contrast-grey-medium));
  color: rgb(var(--v-theme-font));
  text-align: right;
}
.context-input:disabled {
  color: rgb(var(--v-theme-contrast-grey-medium));
}
.checkbox-container {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.execution-context-container {
  padding-top: 5px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0; /* allow children to scroll inside flex */
}

.execution-context-list {
  overflow: auto;
  flex: 1 1 auto;
  min-height: 0;
}
</style>
